import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { billingScopes } from '../../../billing-consts';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { OnGetData } from '../../../services/dialog.service';
import { PermissionService } from '../../../services/permission.service';
import { PricingService } from '../../../services/pricing.service';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-feature-paywall-dialog',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, ButtonDirective, AsyncPipe],
  templateUrl: './feature-paywall-dialog.component.html',
  styleUrls: ['./feature-paywall-dialog.component.scss'],
})
export class FeaturePaywallDialogComponent implements OnGetData {
  private pricingService = inject(PricingService);
  private permissionService = inject(PermissionService);
  private check = inject(ChangeDetectorRef);
  dialogName = 'feature-paywall';

  colors = {
    pro: 'grey-80',
    plus: 'primary',
  };

  features = {
    uploadRaw: {
      key: 'uploadRaw',
      title: 'RAW Upload',
      description: 'Upgrade your plan for RAW uploading and to unlock other premium features.',
      scope: billingScopes.asset.uploadRaw,
    },
    video: {
      key: 'video',
      title: 'Video Collaboration',
      description: 'Upgrade your plan to upload videos and to unlock other premium features.',
      scope: billingScopes.asset.video,
    },
    videoInCover: {
      key: 'videoInCover',
      title: 'Cover Video',
      description: 'Upgrade your plan to add a cover video and to unlock other premium features.',
      scope: billingScopes.gallery.videoInCover,
    },
  };
  productName$: Observable<string>;

  feature: (typeof this.features)['uploadRaw'];
  canStartTrial: boolean;

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 40, spacingY: 40 };
  }

  onGetData(data: { feature: string }) {
    this.feature = this.features[data.feature];
    this.productName$ = this.permissionService.getMinPlanForScope(this.feature.scope);
    this.dialogName = `feature-paywall-${data.feature}`;
    this.canStartTrial = this.pricingService.canStartTrial();
    this.check.detectChanges();
  }
}
